import { styles, variants } from '../ProgressCircleStyles.css';
import { ProgressCircleTheme } from '../ProgressCircleStyles.css';
import { baseTheme } from './ProgressCircleBaseTheme.css';
import { multiVariantStyles } from './ProgressCircleVariants.css';
/*******************
 * Component Theme
 *******************/

const ProgressCircleRedwoodTheme: ProgressCircleTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { ProgressCircleRedwoodTheme };
